const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_60",
  "data-name": "Rectangle 60",
  width: 300,
  height: 79.309,
  fill: "none"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_29",
  "data-name": "Group 29",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M165.97,44.837,156.663,46.2,144.17,51.754a4.363,4.363,0,1,0,3.548,7.972l17.852-7.943a22.344,22.344,0,0,0,.4-6.946",
  transform: "translate(-20.602 -6.524)",
  fill: "#ff9327"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M135.249,83.211l.1,0a43.256,43.256,0,0,0,29.747-10.15,37.41,37.41,0,0,0,13.455-27.228A36.442,36.442,0,0,0,175.765,30.4a5.453,5.453,0,0,0-5.825-3.307l-31.434,4.587a5.454,5.454,0,0,0,.594,10.848,5.52,5.52,0,0,0,.981-.054l26.9-3.926a25.575,25.575,0,0,1,.67,6.881,26.619,26.619,0,0,1-9.636,19.34,32.378,32.378,0,0,1-22.281,7.546l-.056,0-.029,0a5.454,5.454,0,0,0-.4,10.9",
  transform: "translate(-18.917 -3.934)",
  fill: "#092321"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M165.168,5.722A8.866,8.866,0,1,0,176.6.58a8.867,8.867,0,0,0-11.436,5.141",
  transform: "translate(-23.95 0)",
  fill: "#ff9327"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M19.11,31.861c6.447,0,11.031,2.952,13.362,6.758V32.483H45.755V75.829H32.471V69.693c-2.409,3.806-6.992,6.758-13.439,6.758C8.467,76.452,0,67.75,0,54.079S8.467,31.861,19.11,31.861m3.884,11.575c-4.971,0-9.477,3.728-9.477,10.643s4.506,10.8,9.477,10.8c5.049,0,9.478-3.807,9.478-10.72s-4.429-10.72-9.478-10.72",
  transform: "translate(0 -4.636)",
  fill: "#092321"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M91.459,29.559c10.72,0,19.11,8.545,19.11,22.218S102.1,74.15,91.459,74.15c-6.37,0-10.954-2.875-13.362-6.681v6.059H64.814V16.043H78.1V36.317c2.408-3.884,7.146-6.758,13.362-6.758M87.5,41.134c-4.971,0-9.477,3.806-9.477,10.72s4.506,10.72,9.477,10.72c5.049,0,9.556-3.884,9.556-10.8S92.546,41.134,87.5,41.134",
  transform: "translate(-9.431 -2.334)",
  fill: "#092321"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M245.828,76.117H232.544v-5.9a15.794,15.794,0,0,1-13.127,6.37c-10.022,0-16.78-6.914-16.78-18.489V32.77h13.206V56.308c0,5.9,3.34,9.167,8.312,9.167,5.127,0,8.389-3.262,8.389-9.167V32.77h13.284Z",
  transform: "translate(-29.486 -4.768)",
  fill: "#092321"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M277.645,76.584H264.361V33.237h13.284v7.225a16.159,16.159,0,0,1,13.594-7.69V46.832h-3.65c-6.293,0-9.944,2.176-9.944,9.633Z",
  transform: "translate(-38.468 -4.769)",
  fill: "#092321"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M322.084,76.452c-12.74,0-21.906-8.546-21.906-22.3s9.011-22.3,21.906-22.3c12.662,0,21.6,8.39,21.6,21.6a33.728,33.728,0,0,1-.232,3.884H313.384c.466,5.67,3.961,8.312,8.235,8.312a7.064,7.064,0,0,0,6.914-4.195h14.138c-2.1,8.467-9.788,14.993-20.586,14.993m-8.623-26.49h16.624c0-4.739-3.729-7.458-8.157-7.458-4.35,0-7.69,2.641-8.467,7.458",
  transform: "translate(-43.68 -4.636)",
  fill: "#092321"
}));
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 79.309,
    viewBox: "0 0 300 79.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.1721365570b8ac0b4b6ceb62152239c4.svg";
export { ForwardRef as ReactComponent };